import ReactDOMServer from 'react-dom/server'

import { getUserName } from 'services/Utilities'
import { HideOverflow } from 'components/UI'

const getAbsenceBubbleHtml = ({ userId, comments }) => {
  return ReactDOMServer.renderToString(
    <div>
      <div>
        <b>{getUserName(userId, { showEmployeeNumber: true })}</b>
      </div>
      <div>
        {comments?.length > 0
          ? comments.map((comment, index) => (
              <div key={index} className="font-italic">
                <i className="fas fa-comment" />
                <HideOverflow parsedValues={comment.split('')} hideOverflow={100} delimiter={''} hideButton />
              </div>
            ))
          : null}
      </div>
    </div>
  )
}

export default getAbsenceBubbleHtml
